/* eslint-disable prettier/prettier */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from './toastSlice'
import makeRequest from 'src/services/api'
import handleGeneralError from '../helpers/errorHandler'
import { uploadInvoiceUrl, fetchWinnersListUrl } from 'src/services/urls'

const initialState = {
  loading: false,
  data: { hasMore: false, page: 1, totalDocs: 0, nextPage: 0 },
  docs: [],
  error: '',
  pageSize: 10,
  activePage: 0,
}

export const fetchWinnersList = createAsyncThunk(
  'campaignUserData/fetchWinnersList',
  async (data, { dispatch, getState }) => {
    try {
      let query = '?'
      for (let key in data) {
        query += `${key}=${data[key]}&`
      }

      query = query.slice(0, -1)
      const url = fetchWinnersListUrl(query) + query
      const response = await makeRequest(url)
      return { ...response.data.data }
    } catch (e) {
      handleGeneralError(e, { dispatch, showToast })
      return { error: e?.response?.data?.error?.message }
    }
  },
)

export const uploadInvoice = createAsyncThunk(
  'files/uploadInvoice',
  async (data, { dispatch, getState }) => {
    try {
      const formData = new FormData()
      formData.append('file', data.file)
      const response = await makeRequest(
        `${uploadInvoiceUrl()}?orderId=${data.orderId}`,
        'POST',
        formData,
      )
      const { displayMessage, status } = response.data
      if (response.data.statusCode === 200) {
        dispatch(showToast({ title: status, message: displayMessage, color: 'success' }))
        dispatch(setLoading(true))
        dispatch(setActivePage(0))
        dispatch(resetDocs())
        setTimeout(() => {
          dispatch(fetchWinnersList({ page: 1, limit: 500, ...data.filters }))
        }, 1000)
      }
    } catch (e) {
      console.error('Error uploading file:', e)
      handleGeneralError(e, { dispatch, showToast })
    }
  },
)

const luckyDrawWinnersDataSlice = createSlice({
  name: 'luckyDrawWinnersData',
  initialState,
  reducers: {
    resetDocs: (state, action) => {
      state.docs = []
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setActivePage: (state, action) => {
      state.activePage = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWinnersList.fulfilled, (state, action) => {
      state.data = action.payload
      let trackDocs = new Map()
      state.docs.forEach((d) => {
        if (!trackDocs.get(d.id)) trackDocs.set(d.id, d.id)
      })
      let newDocs = []
      action.payload.docs.forEach((d) => (!trackDocs.get(d.id) ? newDocs.push(d) : false))
      state.docs = [...state.docs, ...newDocs]
      state.loading = false
    })
    builder.addCase(fetchWinnersList.rejected, (state, action) => {
      state.loading = false
      state.data = {}
      state.docs = []
      state.error = action.error.message
    })
  },
})
export const { resetDocs, setLoading, setActivePage, setPageSize } =
  luckyDrawWinnersDataSlice.actions
export default luckyDrawWinnersDataSlice.reducer
